/* eslint-disable react/jsx-closing-tag-location */
import React, { Fragment } from 'react';
import styled, { css } from 'styled-components';
import { Accordion } from 'react-accessible-accordion';
import AnchorLink from 'react-anchor-link-smooth-scroll';

import Island from '../shared/Island';
import Navbar from '../shared/Navbar';
import FAQuestion from './FAQuestion';
import Footer from './Footer';
import Section from './Section';
import Title from '../shared/Title';
import Text from '../shared/Text';
import { palette, breakpoints } from '../../constants/styles';
import ScrollToTopOnMount from '../shared/ScrollToTopOnMount';
import {phoneNumber} from "../../constants/constants";

export const StyledFAQList = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  max-width: 750px;
`;

const FAQs = [
  {
    id: 'finauta',
    name: 'Sobre Finauta',
    questions: [
      {
        question: '¿Qué es Finauta?',
        expanded: true,
        answer: (
          <Fragment>
            <Text type="body1">
              Finauta es una empresa mexicana que tiene como fin ayudarte a lograr tus metas
              financieras. Por medio de herramientas financieras amigables y expertos certificados,
              simplificamos las finanzas personales para que tú puedas lograr tus sueños.{' '}
            </Text>
          </Fragment>
        ),
      },
      {
        question: '¿Por qué elegir Finauta?',
        answer: (
          <Fragment>
            <Text type="body1">En Finauta nos caracteriza una cosa: nuestra gente.</Text>

            <Text type="body1">
              Creemos que las relaciones personales son clave para navegar exitosamente en el mar de
              las finanzas personales. Adicionalmente, creemos en que los negocios deben adaptarse
              al estilo de vida de sus usuarios y no lo contrario.
            </Text>

            <Text type="body1">
              Es por esto que juntamos lo mejor de ambos mundos: Un equipo de expertos enfocados en
              tu bienestar financiero y las apps que ya acostumbras utilizar (WhatsApp y tu
              navegador).
            </Text>

            <Text type="body1">
              Además, nuestros expertos están certificados ante la AMIB (Asociación Mexicana de
              Instituciones Bursátiles) y la CNSF (Comisión Nacional de Seguros y Fianzas) para
              poder proveer consejos financieros de manera imparcial. Conoce al equipo aquí
            </Text>
          </Fragment>
        ),
      },
      {
        question: '¿Cómo se diferencían?',
        answer: (
          <Fragment>
            <Title level={5}>Finauta vs. asesores financieros tradicionales</Title>
            <Text type="body1">
              En Finauta, nos diferenciamos vs. otros asesores financieros tradicionales
              principalmente en 2 niveles:
            </Text>
            <Text type="body1">
              Automatización y digitalización del proceso de asesoría financiera. Por medio de
              herramientas financieras gratuitas y contacto con asesores 100% en línea buscamos
              proveer un mejor servicio vs. un esquema de tradicional en el que el asesor contacta y
              visita al cliente sólo si este tiene los suficientes recursos económicos.
            </Text>
            <Text type="body1">
              Imparcialidad. Promovemos el instrumento financiero que mejor se ajuste a tus
              necesidades vs. el instrumento que maximice la comisión del asesor. Nuestros expertos
              ganan si tú estás feliz con el servicio prestado.
            </Text>
            <Title level={5}>Finauta vs. “Robo-asesores”</Title>
            <Text type="body1">
              En Finauta, independientemente de tus metas, trabajas con uno de nuestros expertos
              (asesores financieros certificados).{' '}
            </Text>
            <Text type="body1">
              Nuestra prioridad es entender tus metas y crear una estrategia para que las logres.
              Dependiendo de su situación, tu plan puede incluir recomendaciones sobre cuánto dinero
              ahorrar, dónde invertir tu dinero y/o cómo refinanciar tus deudas.
            </Text>
            <Text type="body1">
              Los “Robo-asesores” se enfocan sólo en la cartera de inversiones que tienes con ellos
              y generalmente no son de mucha ayuda para responder preguntas que van más allá de eso
              (p.ej., ¿cómo obtener los beneficios de deducciones en tu ahorro para el retiro?,
              ¿cómo me cambio de Afore?, ¿debería de comprar o rentar una casa?).
            </Text>
            <Text type="body1">
              Cada situación es diferente y nuestros expertos se toman el tiempo para descubrir
              contigo el mejor plan para ti.
            </Text>
          </Fragment>
        ),
      },
      {
        question: '¿Cómo funciona?',
        answer: (
          <Fragment>
            <Text type="body1">
              Para ayudarte a lograr tus metas financieras creamos herramientas financieras con las
              que podrás entender mejor tus finanzas y conocer los distintos caminos financieros que
              puedes tomar (ahorro, liquidación de deuda, planeación del retiro, etc.)
            </Text>
            <Text type="body1">
              Las herramientas financieras te darán un plan preliminar de acción, pero sabemos que
              tu situación es única. Es por esto que para empezar a tomar acción sobre el camino
              financiero que elijas podrás ponerte en contacto con uno de nuestros expertos.{' '}
            </Text>
            <Text type="body1">
              Nuestros expertos entenderán tu situación a fondo y trabajarán contigo en comparar tus
              opciones para que tomes una decisión informada.
            </Text>
            <Text type="body1">
              Una vez que hayas seleccionado algún instrumento financiero (fondo de ahorro, fondo de
              inversión, plan personal para el retiro, etc.) nuestros expertos te ayudarán paso a
              paso con los trámites necesarios para que así empieces a lograr tus metas financieras.
            </Text>
          </Fragment>
        ),
      },
      {
        question: '¿En qué partes de México funciona?',
        answer: (
          <Fragment>
            <Text type="body1">Nuestros servicios están disponibles en todo México</Text>
          </Fragment>
        ),
      },
      {
        question: '¿Cuánto cuesta?',
        answer: (
          <Fragment>
            <Text type="body1">Es gratis. Sí, en serio.</Text>
          </Fragment>
        ),
      },
      {
        question: '¿Cómo ganan?',
        answer: (
          <Fragment>
            <Text type="body1">
              La institución financiera que tú elijas para llevar a cabo tu plan nos paga una
              comisión por haberte ayudado a encontrarla.
            </Text>
          </Fragment>
        ),
      },
      {
        question: '¿Cómo protegen mis datos?',
        answer: (
          <Fragment>
            <Text type="body1">
              A través de la Ley de Protección de Datos, tus datos no van a ser utilizados para
              ningún otro propósito que no sea el de cumplir tus objetivos y sueños financieros.
            </Text>
          </Fragment>
        ),
      },
      {
        question: '¿Cómo unirme al equipo?',
        answer: (
          <Fragment>
            <Text type="body1">
              ¿Te apasiona ayudar a la gente a lograr sus metas financieras? Simplemente envíanos tu
              CV por WhatsApp o a hola@finauta.com con una pequeña descripción de tus intereses
              profesionales y personales.
            </Text>
          </Fragment>
        ),
      },
      {
        question: '¿Cómo los contacto?',
        answer: (
          <Fragment>
            <Text type="body1">
              Escríbenos por WhatsApp aquí o envíanos un correo a hola@finauta.com
            </Text>
          </Fragment>
        ),
      },
    ],
  },
  {
    id: 'expertos',
    name: 'Sobre nuestros expertos',
    questions: [
      {
        question: '¿Qué los hace expertos?',
        answer: (
          <Fragment>
            <Text type="body1">
              Todos nuestros asesores financieros han perseguido esta profesión por pasión y
              comparten la visión de ayudar a las personas simplificando las finanzas personales.
            </Text>
            <Text type="body1">
              Cuentan con la experiencia y están certificados por los reguladores Mexicanos.
            </Text>
            <Text type="body1">
              Las certificaciones no duran más de 3 años por lo que puedes tener la certeza de que
              nuestros asesores están en constante capacitación, aprendiendo para darte un mejor
              servicio. Conoce al equipo aquí
            </Text>
          </Fragment>
        ),
      },
      {
        question: '¿Cómo me puedo poner en contacto con un experto?',
        answer: (
          <Fragment>
            <Text type="body1">
              Simplemente da click en alguno de los botones que tengan el logo de WhatsApp.
            </Text>
          </Fragment>
        ),
      },
      {
        question: '¿Quién puede platicar con un experto?',
        answer: (
          <Fragment>
            <Text type="body1">Cualquier mayor de edad.</Text>
          </Fragment>
        ),
      },
      {
        question: '¿Qué esperar al platicar con un experto?',
        answer: (
          <Fragment>
            <Text type="body1">
              Puedes esperar una plática en la que buscaremos tener una comprensión más detallada de
              tu situación actual.
            </Text>
            <Text type="body1">
              Una vez entendiendo tu contexto, recibirás de parte de nuestro experto un diagnóstico.
            </Text>
            <Text type="body1">
              Como parte de ese diagnóstico, en caso de que exista algún instrumento financiero que
              te pueda ayudar a lograr tus metas recibirás a la brevedad una lista de
              recomendaciones. (El tiempo de espera depende de la complejidad de los instrumentos
              financieros y va desde la inmediatez hasta 2 días hábiles).
            </Text>
            <Text type="body1">
              Al finalizar el diagnóstico, podrás hacerle preguntas al experto.
            </Text>
            <Text type="body1">
              En el caso de que te interese alguna de las recomendaciones, simplemente manda un
              mensaje a tu experto para que te lleve paso por paso a través de los trámites
              requeridos.{' '}
            </Text>
            <Text type="body1">
              Como te hemos mencionado, en Finauta creemos que las relaciones personales son lo más
              importante.{' '}
            </Text>
            <Text type="body1">
              Es por esto que una vez que tú adquieras alguno de los instrumentos financieros que te
              recomendamos podrás seguir en contacto con tu experto, quien te acompañará en el
              proceso de cumplir tus metas financieras a través de llamadas/mensajes
              semanales/mensuales/anuales dependiendo de tu situación particular.{' '}
            </Text>
          </Fragment>
        ),
      },
      {
        question: 'Cuéntame más sobre sus certificaciones...',
        answer: (
          <Fragment>
            <Text type="body1">
              En México se requiere certificaciones para dar consejos y promover productos
              financieros específicos. Esto con el fin de que las personas tengan la certeza de que
              hablan con un experto en el tema.
            </Text>
            <Text type="body1">
              Las certificaciones más importantes en esta rama, son las avaladas por la AMIB, CNSF y
              CONSAR.
            </Text>
            <Text type="body1">
              Las certificaciones tienen validez por un plazo no mayor a 3 años, por lo que puedes
              tener la certeza de que nuestros expertos están en constante capacitación aprendiendo
              para darte un mejor servicio. Conoce al equipo aquí
            </Text>
          </Fragment>
        ),
      },
    ],
  },
  {
    id: 'recomendaciones',
    name: 'Sobre nuestras recomendaciones',
    questions: [
      {
        question: '¿Cómo se generan las recomendaciones?',
        answer: (
          <Fragment>
            <Text type="body1">
              Nuestras recomendaciones están basadas en tus sueños y metas, para nosotros lo más
              importante es ayudarte a elegir y acompañarte en el proceso. Nuestros expertos
              comparan tus opciones y te dan una visión imparcial.
            </Text>
          </Fragment>
        ),
      },
      {
        question: '¿Qué instrumentos financieros promueven?',
        answer: (
          <Fragment>
            <Text type="body1">
              Los instrumentos que recomendamos están basados en nuestro conocimiento y experiencia
              en el mercado. No estamos casados con ninguna institución financiera, lo que nos
              permite presentarte varias opciones para lograr tus metas.
            </Text>
          </Fragment>
        ),
      },
      {
        question: '¿Qué es un “instrumentos financiero”?',
        answer: (
          <Fragment>
            <Text type="body1">
              Los instrumentos financieros son activos que pueden ser comercializados. Estos activos
              pueden ser efectivo, un derecho contractual para entregar o recibir efectivo u otro
              tipo de instrumento financiero, o evidencia de propiedad de una entidad. En este
              contexto, un instrumento financiero podría ser: fondo de ahorro, Cetes, fondo de
              inversión, pagaré bancario, etc.
            </Text>
          </Fragment>
        ),
      },
      {
        question: '¿Qué pasa si ninguna opción me gusta?',
        answer: (
          <Fragment>
            <Text type="body1">
              En Finauta estamos comprometidos por proveer recomendaciones de calidad, si no cumplen
              con tus expectativas ¡no dudes en decirnos! Esto nos ayudará a seguir mejorando.
            </Text>
            <Text type="body1">
              De lo que puedes tener certeza, es que en el caso de poder darte más opciones eso
              haremos.
            </Text>
          </Fragment>
        ),
      },
      {
        question: 'Si me gusta una de las opciones, ¿qué sigue?',
        answer: (
          <Fragment>
            <Text type="body1">
              Lo que sigue es hacérselo saber a tu experto, quien paso por paso te ayudará a
              realizar todos los trámites necesarios para que así empieces a lograr tus metas
              financieras lo antes posible.
            </Text>
          </Fragment>
        ),
      },
      {
        question: '¿Qué pasa después de adquirir un instrumento financiero?',
        answer: (
          <Fragment>
            <Text type="body1">
              Realizamos un seguimiento a tu plan a través de mensajes o llamadas con el fin de
              acompañarte en el proceso de cumplir tus metas.
            </Text>
          </Fragment>
        ),
      },
      {
        question: '¿Quién maneja mi dinero?',
        answer: (
          <Fragment>
            <Text type="body1">
              Tu dinero lo maneja la institución financiera que elijas. Finauta no maneja tu dinero,
              nosotros sólo te ayudamos a tomar la mejor decisión.
            </Text>
          </Fragment>
        ),
      },
    ],
  },
  {
    id: 'definiciones',
    name: 'Definiciones',
    questions: [
      {
        question: '¿A qué se refieren con “invertir tu dinero”?',
        answer: (
          <Fragment>
            <Text type="body1">
              Definimos invertir como el acto de comprometer dinero hoy con la expectativa de
              obtener un ingreso o ganancia adicional en el futuro. El objetivo de invertir es hacer
              crecer tu dinero en el tiempo.
            </Text>
          </Fragment>
        ),
      },
      {
        question: '¿A qué se refieren con “Inflación”?',
        answer: (
          <Fragment>
            <Text type="body1">
              Es la tasa de crecimiento promedio de un período a otro de los precios de una canasta
              de bienes y servicios.
            </Text>
          </Fragment>
        ),
      },
      {
        question: '¿Qué es un Fondo de Ahorro”?',
        answer: (
          <Fragment>
            <Text type="body1">
              Es una inversión de aportaciones regulares en un portafolio diversificado diseñado
              para lograr tus metas. Asimismo, podría tener un componente de seguro de vida, para
              que en caso de fallecimiento tu pareja o familia obtengan lo que habrías ahorrado.
            </Text>
            <Title level={6}>¿Cuál es su rendimiento?</Title>
            <Text type="body1">
              Usualmente su rendimiento promedio es mayor que Cetes debido a los beneficios de la
              diversificación. Sin embargo, esto dependerá de tu perfil de riesgo.{' '}
            </Text>
            <Title level={6}>¿Qué riesgo tiene?</Title>
            <Text type="body1">
              Dependerá del tipo de portafolio que elijas. Recuerda que a mayor riesgo, mayor
              rendimiento esperado.
            </Text>
            <Title level={6}>¿Quién maneja mi dinero?</Title>
            <Text type="body1">Una institución financiera (p.ej., Sura, Allianz, Old Mutual).</Text>
            <Title level={6}>¿Qué costo tiene?</Title>
            <Text type="body1">
              Es el instrumento con mayores comisiones (estas dependen de la institución
              financiera), pero los mayores beneficios por gestión activa y beneficios adicionales
              (p.ej., seguro de vida).
            </Text>
          </Fragment>
        ),
      },
      {
        question: '¿Qué es un Fondo de Inversión?',
        answer: (
          <Fragment>
            <Text type="body1">
              Es un vehículo de inversión que consolida las aportaciones de diversos ahorradores,
              los cuales ceden a administradores profesionales la toma de decisiones sobre la
              inversión de su patrimonio. La inversión se realiza de forma conjunta en los activos
              que el equipo gestor considere adecuados sujeto a la estrategia de inversión
              previamente definida del fondo.
            </Text>
            <Title level={6}>¿Cuál es su rendimiento y qué riesgo tiene?</Title>
            <Text type="body1">
              Dependerá del tipo de portafolio que elijas. Recuerda que a mayor riesgo, mayor
              rendimiento esperado.
            </Text>
            <Title level={6}>¿Quién maneja mi dinero?</Title>
            <Text type="body1">Una institución financiera (p.ej., Sura, Allianz, Old Mutual).</Text>
          </Fragment>
        ),
      },
      {
        question: '¿Qué es un Plan Personal para el Retiro (PPR)?',
        answer: (
          <Fragment>
            <Text type="body1">
              Es una inversión para complementar tu retiro. Se invierte en un portafolio
              diversificado de inversión. El ahorro es deducible de impuestos, tú eliges el perfil
              de riesgo del portafolio y podrás retirar parcial o totalmente tu ahorro antes de los
              65 años (menos impuestos) si así lo deseas.
            </Text>
            <Title level={6}>¿Cuál es su rendimiento?</Title>
            <Text type="body1">
              En general, el rendimiento promedio es mayor que las Afores (a cualquier nivel de
              edad) debido a que no se tienen las mismas restricciones sobre dónde invertir el
              dinero.
            </Text>
            <Title level={6}>¿Qué riesgo tiene?</Title>
            <Text type="body1">
              Dependerá del tipo de portafolio que elijas. Recuerda que a mayor riesgo, mayor
              rendimiento esperado.
            </Text>
            <Title level={6}>¿Quién maneja mi dinero?</Title>
            <Text type="body1">Una institución financiera (p.ej., Sura, Allianz, Old Mutual).</Text>
          </Fragment>
        ),
      },
      {
        question: '¿Qué son los CETES?',
        answer: (
          <Fragment>
            <Text type="body1">
              Son los “Certificados de la Tesorería de la Federación”, los cuales son emitidos por
              el gobierno mexicano.
            </Text>
            <Title level={6}>¿Cuál es su rendimiento?</Title>
            <Text type="body1">
              Su rendimiento promedio es mayor que las cuentas de ahorro o cheques, pero se
              encuentra por debajo de la bolsa de valores y fondos de ahorro.
            </Text>
            <Title level={6}>¿Qué riesgo tiene?</Title>
            <Text type="body1">
              Debido a que son un préstamo al gobierno mexicano, se considera como el instrumento
              financiero más seguro.
            </Text>
            <Title level={6}>¿Quién maneja mi dinero?</Title>
            <Text type="body1">
              Es un préstamo, el cual el gobierno mexicano se compromete a pagar con intereses.
            </Text>
            <Title level={6}>¿Qué costo tiene?</Title>
            <Text type="body1">No tiene ningún costo a través de CetesDirecto</Text>
          </Fragment>
        ),
      },
      {
        question: '¿Qué es un Pagaré Bancario?',
        answer: (
          <Fragment>
            <Text type="body1">
              Un pagaré es un instrumento de inversión a un plazo que paga una tasa fija, donde el
              capital más los intereses se pagan al final del plazo de la inversión. En el cual
              existen plazo de inversión de 1 hasta 364 días. (BBVA)
            </Text>
          </Fragment>
        ),
      },
      {
        question: '¿Qué es la Bolsa Mexicana de Valores?',
        answer: (
          <Fragment>
            <Text type="body1">
              Es un mercado en el que se llevan a cabo las operaciones de compra/venta de acciones o
              deuda de empresas mexicanas.{' '}
            </Text>
            <Title level={6}>¿Cuál es su rendimiento?</Title>
            <Text type="body1">
              Su rendimiento promedio es mayor que Cetes y fondos de ahorro debido a su enfoque en
              títulos de valores de empresas. Sin embargo, requerirás una inversión mayor para
              diversificar tu inversión.
            </Text>
            <Title level={6}>¿Qué riesgo tiene?</Title>
            <Text type="body1">
              Dependerá del tipo de portafolio que construyas. Recuerda que a mayor riesgo, mayor
              rendimiento esperado.
            </Text>
            <Title level={6}>¿Quién maneja mi dinero?</Title>
            <Text type="body1">Una casa de bolsa (p.ej., GBM, Vector, Value).</Text>
            <Title level={6}>¿Qué costo tiene?</Title>
            <Text type="body1">
              Dependiendo de la casa de la casa bolsa, se cobra por una comisión por transacción y
              por manejo de cuenta. Las comisiones son menores que en los fondos de ahorro, pero tú
              deberás definir dónde invertir.
            </Text>
          </Fragment>
        ),
      },
      {
        question: '¿Qué es "AFORE"?',
        answer: (
          <Fragment>
            <Text type="body1">
              Las Administradoras de Fondos para el Retiro (Afores) son instituciones financieras
              que se dedican a administrar las cuentas individuales de los trabajadores y a
              canalizar sus recursos a inversiones.
            </Text>
            <Title level={6}>¿Cuál es su rendimiento?</Title>
            <Text type="body1">
              Dependerá de tu edad, ya que tu ahorro se asignará un portafolio predefinido de
              política de inversión.{' '}
            </Text>
            <Title level={6}>¿Qué riesgo tiene?</Title>
            <Text type="body1">
              Dependerá de tu edad, conforme menor sea tu edad mayor será el riesgo de tu portafolio
              predefinido.
            </Text>
            <Title level={6}>¿Quién maneja mi dinero?</Title>
            <Text type="body1">
              La Afore en la que estés registrado (p.ej., XXI Banorte, Citibanamex, Sura)
            </Text>
          </Fragment>
        ),
      },
      {
        question: '¿Qué son las aportaciones complementarias a mi Afore?',
        answer: (
          <Fragment>
            <Text type="body1">
              Son un apartado dentro de tu Afore para que complementes tu retiro. El ahorro es
              deducible de impuestos, tu dinero se invierte en un portafolio estándar y no lo podrás
              retirar antes de los 65 años sin penalizaciones.
            </Text>
          </Fragment>
        ),
      },
    ],
  },
];

const StyledFAQ = styled.div`
  position: relative;
  overflow: hidden;
`;

const StyledFAQSection = styled(Section)`
  padding: 20px 40px 20px 40px;

  ${breakpoints.tablet} {
    margin-top: 20px;
  }

  ${breakpoints.tabletLandscape} {
    margin-top: 50px;
  }

  ${breakpoints.desktop} {
    margin-top: 90px;
  }
`;

const StyledShortcuts = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  width: 100%;
  max-width: 615px;
  text-align: left;
`;

const FAQ = () => (
  <Fragment>
    <StyledFAQ>
      <ScrollToTopOnMount />

      <Navbar style={{ alignSelf: 'flex-start' }} />
      <StyledFAQSection>
        <Title level={2} align="center">
          FAQ
        </Title>
        <Text
          type="body1"
          align="left"
          styles={css`
            max-width: 615px;
            margin-bottom: 1rem;
          `}
        >
          Nuestra sección de preguntas frecuentes te ayudará a entender cómo Finauta te puede ayudar
          a lograr tus metas financieras. Si no encuentras lo que estás buscando,
          <a
            href={`https://api.whatsapp.com/send?phone=${phoneNumber}&text=${encodeURIComponent(
              'Hola 👋 Tengo una pregunta que no encontré en la sección de preguntas frecuentes: ',
            )}`}
            style={{ color: palette.terciaryColor }}
          >
            ¡Mándanos un mensaje!
          </a>
        </Text>
        <StyledShortcuts>
          <Text
            type="body1"
            medium
            align="left"
            styles={css`
              margin-right: 0.3rem;
            `}
          >
            Ir a:
          </Text>
          {FAQs.map((section) => (
            <AnchorLink
              key={`anchor-to-${section.id}`}
              href={`#${section.id}`}
              style={{
                textTransform: 'capitalize',
                marginRight: '0.3rem',
                color: palette.terciaryColor,
              }}
            >
              {section.id}
            </AnchorLink>
          ))}
        </StyledShortcuts>
        <StyledFAQList>
          {FAQs.map((section) => (
            <div key={section.id} id={section.id} style={{ width: '100%' }}>
              <Title
                level={4}
                color={palette.terciaryColor}
                styles={css`
                  margin-bottom: 0px;
                  margin-top: 20px;
                  align-self: flex-start;
                `}
              >
                {section.name}
              </Title>
              <Accordion
                accordion={false}
                style={{ width: '100%', marginTop: '10px', maxWidth: '750px' }}
              >
                {section.questions.map((question) => (
                  <FAQuestion
                    question={question}
                    key={question.question}
                    expanded={question.expanded}
                  />
                ))}
              </Accordion>
            </div>
          ))}
        </StyledFAQList>
      </StyledFAQSection>
      <Footer />
    </StyledFAQ>
  </Fragment>
);

export default FAQ;
